import { cdataFetch } from "../../../api/cdataFetch";
import { IBillingUsage } from "../../../models";

export async function getBillingUsage() {
  return cdataFetch<IBillingUsage>({
    method: "GET",
    url: "/billing/usage",
  });
}
